<template>
    <div class="af-app af-login">
        <LoginForm />
    </div>
</template>

<script>
    import LoginForm from './components/LoginForm.vue';

    export default {
        name: 'App',

        components: {
            LoginForm,
        },

        data() {
            return {
            };
        },

        methods: {},
    };
</script>
